import React from 'react';
import { SettingsIcon, MailIcon } from 'lucide-react';
import { SUPPORT_EMAIL } from '../lib/config';
export function Support() {
  return <footer className="px-5 pb-16 pt-6" data-id="element-176" data-mp="1cqlo8303vqfu">
      <div className="flex flex-col items-center gap-3 rounded-2xl border border-white/10 bg-white/5 p-5 text-center" data-id="element-177" data-mp="xucq54rybj50">
        <span className="flex h-12 w-12 items-center justify-center rounded-full bg-teal-500/15" data-id="element-178" data-mp="12se81mdn5cew">
          <SettingsIcon className="h-6 w-6 text-teal-300" aria-hidden="true" data-id="element-179" data-mp="p1iv9z00ub61" />
        </span>
        <p className="text-sm font-bold text-white" data-id="element-180" data-mp="tu2at1i9rgdh">Soporte</p>
        <p className="text-xs text-teal-100/70" data-id="element-181" data-mp="f44qiwngnatk">
          ¿Tenés una duda antes o después de comprar? Escribinos y te
          respondemos.
        </p>
        <a href={`mailto:${SUPPORT_EMAIL}`} className="inline-flex items-center gap-2 rounded-full border border-teal-400/30 bg-teal-500/10 px-4 py-2 text-sm font-semibold text-teal-200" data-id="element-182" data-mp="k0lftu6ebv88">
          <MailIcon className="h-4 w-4" aria-hidden="true" data-id="element-183" data-mp="2ewif8mde7zbz" />
          {SUPPORT_EMAIL}
        </a>
      </div>
      <p className="mt-6 text-center text-[11px] text-teal-100/40" data-id="element-184" data-mp="29xnyrr2wemv1">
        © {new Date().getFullYear()} Kit Consultorio Sencillo · Producto
        digital. Todos los derechos reservados.
      </p>
    </footer>;
}